const Genesis = require("../Genesis.js")
import { Toast } from "bootstrap";
import { post } from "jquery";
import { WorkflowHandler } from "../Workflow/WorkflowHandler";
import { Modal } from "bootstrap";
import { BlockPageHelper, PreLoadHelper } from "../Helpers/helpers";
import Swal from "sweetalert2";
import { WOWorkflowActionNames } from "./WOWorkflowActionNames";
import { MapComponent } from '../Shared/GoogleMap/MapComponent';
import { ButtonBadge } from "../Components/ButtonBadge";

export class ISiteMobileWorkOrderViewPage {
    private modal: Modal | null = null;
    private isActionsPopulated = false;
    private mapComponent: MapComponent = new MapComponent()

    public Init() {
        $(document).ready(() => {
            WorkflowHandler.InitWorkflowButtons();
           
            const placeholder = $("#main-content");
            const id = $("#recordId").val();
            
            BlockPageHelper.block();
            
            $.ajax({                
                cache: false,                
                url: Genesis.url(`/WorkOrder/_ViewContent/${id}`)
            }).done((html) => {
                BlockPageHelper.unblock();
                placeholder.html(html);
                
                $("#Item1_WorkOrderDetails_MakeSafe").change(() => {
                    const recordId = $("#recordId").val() as number;
                    post({
                        url: Genesis.url('/WorkOrder/UpdateToggleField'),
                        data:
                        {
                            id: recordId,
                            isToggled: $("#Item1_WorkOrderDetails_MakeSafe").is(":checked"),
                            eToggleField: 'MakeSafe'
                        }
                    }).then(() => {
                        var makeSafeToast: Toast = Toast.getOrCreateInstance("#makeSafeToast");
                        makeSafeToast.show();
                    });
                });

                $("#Item1_WorkOrderDetails_HealthAndSafetyIssue").change(() => {
                    const recordId = $("#recordId").val() as number;
                    post({
                        url: Genesis.url('/WorkOrder/UpdateToggleField'),
                        data:
                        {
                            id: recordId,
                            isToggled: $("#Item1_WorkOrderDetails_HealthAndSafetyIssue").is(":checked"),
                            eToggleField: 'HealthAndSafetyIssue'
                        }
                    }).then(() => {
                        var makeSafeToast: Toast = Toast.getOrCreateInstance("#makeSafeToast");
                        makeSafeToast.show();
                    });
                });

                $("#Item1_WorkOrderDetails_FollowOnWorkRequired").change(() => {
                    const recordId = $("#recordId").val() as number;
                    post({
                        url: Genesis.url('/WorkOrder/UpdateToggleField'),
                        data:
                        {
                            id: recordId,
                            isToggled: $("#Item1_WorkOrderDetails_FollowOnWorkRequired").is(":checked"),
                            eToggleField: 'FollowOnWorkRequired'
                        }
                    }).then(() => {
                        var makeSafeToast: Toast = Toast.getOrCreateInstance("#makeSafeToast");
                        makeSafeToast.show();
                    });
                });

                $("#btnUpdateCost").click((e: any) => {
                    var estimatedCost = $("#Item1_WorkOrderDetails_CostEstimated").val();
                    $("#Item1_WorkOrderDetails_CostEstimated").next().next().hide();

                    if (!$.isNumeric(estimatedCost)) {
                        $("#Item1_WorkOrderDetails_CostEstimated").addClass("invalid");
                        $("#Item1_WorkOrderDetails_CostEstimated").next().next().text("Please enter a Valid Estimated Cost");
                        $("#Item1_WorkOrderDetails_CostEstimated").next().next().show();
                        return false;
                    }
                    const recordId = $("#recordId").val() as number;
                    post({
                        url: Genesis.url('/WorkOrder/UpdateEstimatedCost'),
                        data:
                        {
                            id: recordId,
                            estimatedCost: estimatedCost
                        }
                    }).then(() => {
                        var estimatedCostToast = Toast.getOrCreateInstance("#estimatedCostToast");
                        estimatedCostToast.show();
                    });
                });

                this.mapComponent.initMap();

                $("#propertylink").click(function () {
                    $('#propertylinklist').slideToggle('slow');
                });

                $("#assetlink").click(function () {
                    $('#assetlinklist').slideToggle('slow');
                });
                $("#contactpersonlink").click(function () {
                    $('#contactpersonlinklist').slideToggle('slow');
                });

                $("#affectedpersonlink").click(function () {
                    $('#affectedpersonlinklist').slideToggle('slow');
                });

                $("#idEditPriority").click(function () {
                    $('.priority-content').show();
                });
                $("#btnCancelUpdate").click(function () {
                    $('.priority-content').hide();
                });

                $("#btnUpdatePriority").click(() => {
                    const recordId = $("#recordId").val() as number;
                    const priorityId = $("#Item1_WorkOrderDetails_PriorityID").val() as number;
                    post({
                        url: Genesis.url('/WorkOrder/UpdatePriority'),
                        data:
                        {
                            id: recordId,
                            priorityId: priorityId
                        }
                    }).then(() =>
                        location.reload()
                    );
                });

                $('.property-hazard-detail').each(function () {
                    $(this).click(() =>
                        post({
                            url: Genesis.url('/WorkOrder/GetPropertyHazards'),
                            data:
                            {
                                propertyId: $(this).data("propertyid"),
                                locationId: $(this).data("locationid")
                            }
                        }).then((result) => {
                            const propertyhazardModal = document.getElementById('propertyHazardModal');
                            if (propertyhazardModal != null) {
                                $("#propertyhazard-content").html(result);
                                var modal = new Modal(propertyhazardModal, { backdrop: 'static', keyboard: false });
                                modal.show();
                            }
                        })
                    );
                });

                if ($("#isQuoteRequired").val() === "True") {
                    this.ShowQuoteRequiredModal();
                };
                const badges = new ButtonBadge();
                badges.Init();
            }).fail(() => {
                BlockPageHelper.unblock();
                placeholder.html('<div class="alert alert-danger">Failed to load work order details. Please try again.</div>');
            });
        });
    }
    public ShowQuoteRequiredModal() {
        const quoteRequiredModal = document.getElementById('quoteRequiredModal');
        if (quoteRequiredModal != null) {
            this.modal = new Modal(quoteRequiredModal, { backdrop: 'static', keyboard: false });
            this.modal.show();
        }
    }
};